import { components } from "@/__openapi__/backend/schema";

export type ApiBillingStrategyEnum = components["schemas"]["StripeSubscriptionBillingStrategy"];

export enum BillingStrategyEnum {
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

// Compile-time assertion: all local enum values must be valid API values
type AssertAssignable<T extends U, U> = T;
type _BillingStrategyValuesAreApi = AssertAssignable<
  (typeof BillingStrategyEnum)[keyof typeof BillingStrategyEnum],
  ApiBillingStrategyEnum
>;
